import * as Cesium from "cesium";
import { getTileset } from "./getTileset";

export function removeTileset(fileId: number, viewer: Cesium.Viewer): boolean {
  const ts = getTileset(fileId, viewer);
  if (!ts) return false;
  return viewer.scene.primitives.remove(ts);
}
